module.exports = __webpack_public_path__ + "img/img7.c381965c.png";